<script lang="ts">
	import {
		HelpingHandIcon,
		LineChartIcon,
		PresentationIcon,
		ShieldAlertIcon,
		SparklesIcon
	} from 'lucide-svelte';
	import FeatureCard from './_components/feature-card.svelte';
</script>

<div
	class="mx-auto mb-24 mt-32 flex h-auto w-full max-w-[1200px] scroll-mt-16 flex-col items-center justify-center"
>
	<div class="bg-lines-pattern mt-60 max-h-[1000px] max-w-[1000px]" />
	<div
		class="relative mx-auto flex h-auto w-full flex-col-reverse items-center justify-between gap-4 px-8 lg:grid lg:grid-cols-12"
	>
		<enhanced:img
			src="/static/images/star_full.png"
			alt="img"
			class="absolute right-[40px] top-[230px] h-4 w-4"
		/>
		<enhanced:img
			src="/static/images/star_full.png"
			alt="img"
			class="absolute left-[80px] top-[170px] h-4 w-4"
		/>
		<div class="col-span-12 flex flex-col items-center justify-center gap-3 lg:mt-8">
			<h2 class="text-center text-4xl sm:text-5xl">
				With <span class="text-primary">Meeko+</span><br />Meeko is Proactive
			</h2>
			<p class="max-w-md text-center font-light text-lightTertiary">
				Meeko can not only answer all of your question - Meeko proactively helps you improve at the
				game.
			</p>
		</div>
	</div>
	<div class="bg-grid-pattern mt-96 max-h-[800px] max-w-[800px] lg:ml-96" />
	<div class="mt-8 grid grid-cols-1 gap-3 px-8 md:grid-cols-2 lg:grid-cols-3 lg:grid-rows-2">
		<FeatureCard
			title="Session Summaries"
			description="Meeko summarizes your gaming sessions, giving you insights into areas where you can improve and where you're performing best."
		>
			<SparklesIcon slot="icon" class="h-6 w-6 text-lightTertiary" />
		</FeatureCard>
		<FeatureCard
			title="Pre-Game Info"
			description="Meeko can give you valuable insights before you get into your game, such as win-cons, how to win your matchup and key cooldowns to watch out for."
		>
			<PresentationIcon slot="icon" class="h-6 w-6 text-lightTertiary" />
		</FeatureCard>
		<FeatureCard
			title="Protect You From Losses"
			description="Meeko is smart, he can recognize when it's time to take break and warn you when you're tilt playing, on a losing spree or in a losing queue."
		>
			<ShieldAlertIcon slot="icon" class="h-6 w-6 text-lightTertiary" />
		</FeatureCard>
		<FeatureCard
			title="Learning Objectives"
			description="Together with Meeko, you can setup learning objectives for you to focus on any given week or session. Meeko makes sure your on track."
		>
			<HelpingHandIcon slot="icon" class="h-6 w-6 text-lightTertiary" />
		</FeatureCard>
		<FeatureCard
			title="Praising Your Progress"
			description="Meeko not only helps you improve - but also actively praises your progress when you rank up and improve on your learning objectives."
		>
			<LineChartIcon slot="icon" class="h-6 w-6 text-lightTertiary" />
		</FeatureCard>
	</div>
</div>
